const commonHeadScripts = [];
const commonHeadScriptsMobile = [];

// eslint-disable-next-line import/prefer-default-export
export { commonHeadScripts, commonHeadScriptsMobile };
